import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnitsDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 8.00011V9.00011H8V8.00011H7ZM17 8.00011H16V9.00011H17V8.00011ZM8 2.99839V2.99839V0.998391C6.89543 0.998391 6 1.89382 6 2.99839H8ZM8 8.00011V2.99839H6V8.00011H8ZM3 9.00011H7V7.00011H3V9.00011ZM3 9.00011V7.00011C1.89543 7.00011 1 7.89554 1 9.00011H3ZM3 22.0001V9.00011H1V22.0001H3ZM3 22.0001L3 22.0001H1C1 23.1047 1.89543 24.0001 3 24.0001V22.0001ZM21 22.0001H3V24.0001H21V22.0001ZM21 22.0001V24.0001C22.1046 24.0001 23 23.1047 23 22.0001H21ZM21 9.00011V22.0001H23V9.00011H21ZM21 9.00011H23C23 7.89554 22.1046 7.00011 21 7.00011V9.00011ZM17 9.00011H21V7.00011H17V9.00011ZM16 2.99839V8.00011H18V2.99839H16ZM16 2.99839H18C18 1.89382 17.1046 0.998391 16 0.998391V2.99839ZM8 2.99839H16V0.998391H8V2.99839Z",
			fill: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.5,
			y: 12.5,
			width: 1,
			height: 1,
			fill: "#8895A7",
			stroke: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.5,
			y: 12.5,
			width: 1,
			height: 1,
			fill: "#8895A7",
			stroke: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 12.5,
			width: 1,
			height: 1,
			fill: "#8895A7",
			stroke: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 7.5,
			width: 1,
			height: 1,
			fill: "#8895A7",
			stroke: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16.5,
			y: 17.5,
			width: 1,
			height: 1,
			fill: "#8895A7",
			stroke: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.5,
			y: 17.5,
			width: 1,
			height: 1,
			fill: "#8895A7",
			stroke: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 17.5,
			width: 1,
			height: 4,
			fill: "#8895A7",
			stroke: "#8895A7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.5,
			y: 22.5,
			width: 1,
			height: 1,
			fill: "#8895A7",
			stroke: "#8895A7"
		})
	]
});
export default SvgUnitsDefault;
